<table>
  <thead>
    <tr>
      <th class="subtable icon"></th>
      <th class="subtable string">{{'global.municipio' | translate}}</th>
      <th class="subtable string">{{'global.finca' | translate}}</th>
      <th class="subtable string">{{'usuarios.productor.table.tabs.huertos.campanya' | translate}}</th>
      <th class="subtable number">{{'usuarios.productor.table.tabs.huertos.superficie' | translate}}</th>
      <th class="subtable number">{{'usuarios.productor.table.tabs.huertos.arboles' | translate}}</th>
      <th class="subtable number">{{'usuarios.productor.table.tabs.huertos.aforo' | translate}}</th>
    </tr>
  </thead>
  <tbody class="clickable" *ngFor="let huerto of huertosList; let i=index;">
    <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
      <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down' : 'fas fa-angle-right'"
        title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
      </td>
      <td class="string">{{huerto.desMunicipio}}</td>
      <td class="string">{{huerto.desFinca}}</td>
      <td class="string">{{huerto.anyoCampanya}}</td>
      <td>{{huerto.superficie | number : '.2' : defaultLanguage}}</td>
      <td>{{huerto.nPlantas | number : '' : defaultLanguage}}</td>
      <td>{{huerto.aforo | number : '.2' : defaultLanguage}}</td>
    </tr>
    <tr *ngIf="dropdownInfo === i">
      <td colspan="6">
        <content>
          <app-pro-marcas-huertos [productorId]="huerto.productorId" [marcasHuertos]="huerto.cultivosMarcaAccesibles">
          </app-pro-marcas-huertos>
        </content>
      </td>
    </tr>
  </tbody>
  <tfoot *ngIf="!huertosList || (huertosList && huertosList.length < 1)">
    <tr>
      <td colspan="7">
        {{'global.noContent' | translate}}
      </td>
    </tr>
  </tfoot>
</table>
<app-paginator *ngIf="huertosList && huertosList.length > 0" [itemsPerPage]="itemsPerPage"
  [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
  (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
</app-paginator>
